import { baseApi } from './baseSplit';
import { ACCOUNT_LIST, GET_LOGGED_IN_USER, GET_USER_NOTIFICATION, DELETE_CUSTOMER, _header } from '../../globals';

const accountEndPoints = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getAccountList: build.mutation({
            query: (request) => ({
                url: ACCOUNT_LIST,
                method: 'POST',
                headers: _header,
                body: request,
            }),
        }),
        getLoggedInUser: build.mutation({
            query: () => ({
                url: GET_LOGGED_IN_USER,
                method: 'POST',
                headers: _header,
                body: {},
            }),
        }),
        getUserNotification: build.mutation({
            query: (request) => ({
                url: GET_USER_NOTIFICATION,
                method: 'POST',
                headers: _header,
                body: request,
            }),
        }),
        deleteCustomer: build.mutation({
            query: (request) => ({
                url: DELETE_CUSTOMER,
                method: 'POST',
                headers: _header,
                body: request,
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetAccountListMutation,
    useGetLoggedInUserMutation,
    useGetUserNotificationMutation,
    useDeleteCustomerMutation,
} = accountEndPoints;
